import store from "@/store";
import requestService from "@/service/requestService";
import { INSPECT_TYPE } from "@/model/InspectType";

export default class PaymentService {
  reqService: requestService;
  totalCache: number;
  totalCalcZk: number;
  totalCacheNex: number;
  totalCalcZkNex: number;
  testCalcZkNex: number;

  constructor() {
    this.reqService = new requestService();
    this.totalCache = 0;
    this.totalCalcZk = 0;
    this.totalCacheNex = 0;
    this.totalCalcZkNex = 0;
    this.testCalcZkNex = 0;
  }

  getTotalShohiyou() {
    let state = store.getters["Shohiyou/total"];
    return { "zn":state.totalZn , "zk":state.totalZk, "flg": state.isConfirm };
  }

  getTotalCoupon() {
    let state = store.getters["Coupon/total"];
    return { "zn":state.subTotalZn , "zk":state.subTotalZk, "flg": state.isConfirm };
  }

  getSumLegal56() {
    let state = store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.LEGAL56);
    let confirm = store.getters["InspectSeibi/isConfirmLegal56"];
    // store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.LEGAL56),
    // store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.RECOMMEND)
    return { "zn":state.totalZn , "zk":state.totalZk, "flg": confirm };
  }

  getSumRecommend() {
    let state = store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.RECOMMEND);
    let confirm = store.getters["InspectSeibi/isConfirmRecommend"];
    return { "zn":state.totalZn , "zk":state.totalZk, "flg": confirm };
  }

  getTotalOption() {
    let state = store.getters["Option/total"];
    return { "zn":state.subTotalZn , "zk":state.subTotalZk, "flg": state.isConfirm };
  }

  getSumPriceNex1() {
    let state = store.getters["InspectSeibi/sumPriceByTypeForNextage"](INSPECT_TYPE.LEGAL56,1);
    let confirm = store.getters["InspectSeibi/isConfirmLegal56"];
    return { "zn":state.totalZn , "zk":state.totalZk, "flg": ( confirm == 1 || confirm == 2 )? 1: 0 };
  }

  getSumPriceNex2() {
    let state = store.getters["InspectSeibi/sumPriceByTypeForNextage"](INSPECT_TYPE.LEGAL56,2);
    let confirm = store.getters["InspectSeibi/isConfirmLegal56"];
    return { "zn":state.totalZn , "zk":state.totalZk, "flg": ( confirm == 1 || confirm == 3 )? 1 : 0 };
  }

  getTotalKouchinNex() {

    let sum1: any = this.getTotalCoupon();
    let state = store.getters["Shohiyou/shohiyouZn"];

    let kouchin1 = store.getters["InspectSeibi/sumKouchinByTypeForNextage"](INSPECT_TYPE.LEGAL56,1);
    let kouchin2 = store.getters["InspectSeibi/sumKouchinByTypeForNextage"](INSPECT_TYPE.LEGAL56,2);

    return sum1.zn + kouchin1.totalZn + kouchin2.totalZn + state.subTotalKazei;
    // let confirm = store.getters["InspectSeibi/isConfirmLegal56"];
    // return { "zn":state.totalZn , "zk":state.totalZk, "flg": confirm }
  }

  // 課税確定項目を合算
  getTotalKazeiBase() {
    let sum1: any = this.getTotalCoupon();
    let sum2: any = this.getSumLegal56();
    let sum3: any = this.getSumRecommend();
    let sum4: any = this.getTotalOption();

    let totalZk: number = sum1.zk + sum2.zk + sum3.zk + sum4.zk;
    let totalZn: number = sum1.zn + sum2.zn + sum3.zn + sum4.zn;

    return { "zn":totalZn , "zk":totalZk, "flg": true };
  }
  getTotalKazeiBaseNex() {
    let sum1: any = this.getTotalCoupon();
    let sum2: any = this.getSumPriceNex1();

    let totalZk: number = sum1.zk + sum2.zk;
    let totalZn: number = sum1.zn + sum2.zn;

    return { "zn":totalZn , "zk":totalZk, "flg": true };
  }

  // 課税確定項目に残りの課税を足して課税合計を出す
  getTotalKazeiSum() {
    let sum1: any = this.getTotalKazeiBase();
    let state = store.getters["Shohiyou/shohiyouZn"];

    return sum1.zn + state.subTotalKazei;
  }
  // 税抜きで集計した内容に課税して税込みを算出する
  setTotalCalc() {
    let promise = new Promise((resolve, reject) => {
      let sum1: any = this.getTotalKazeiBase();
      let sum2: any = this.getTotalShohiyou();
      let state = store.getters["Shohiyou/shohiyouZn"];

      let totalZn: number = sum1.zn + sum2.zn;
      let totalZnCalc: number = sum1.zn + state.subTotalKazei;

      // 多重起動防止：金額変更のチェック
      if (this.totalCache == totalZn) {
        resolve();
      } else {
        this.totalCache = totalZn;
        // 課税計算
        this.reqService.getZeikomi( totalZnCalc ).then(
          (response: any) => {
            if (response) {
              this.totalCalcZk =  response.priceZk + state.subTotalHikazei;
            }
            resolve();
          },
          (err: any) => { reject(); }
        );
      }
    });
    return promise;
  }

  setTotalCalcNex() {
    let promise = new Promise((resolve, reject) => {
      let sum1: any = this.getTotalKazeiBaseNex();
      let sum2: any = this.getTotalShohiyou();
      let state = store.getters["Shohiyou/shohiyouZn"];

      let totalZn: number = sum1.zn + sum2.zn;
      let totalZnCalc: number = sum1.zn + state.subTotalKazei;

      // 多重起動防止：金額変更のチェック
      if (this.totalCacheNex == totalZn) {
        resolve();
      } else {
        this.totalCacheNex = totalZn;
        // 課税計算
        this.reqService.getZeikomi( totalZnCalc ).then(
          (response: any) => {
            if (response) {
              this.totalCalcZkNex =  response.priceZk + state.subTotalHikazei;
            }
            resolve();
          },
          (err: any) => { reject(); } );
      }
    });
    return promise;
  }

  setDemandAnswerNex(num: number) {
    let promise = new Promise((resolve, reject) => {
      let sum1: any = this.getTotalKazeiBase();
      // let sum2: any = this.getTotalShohiyou();
      let state = store.getters["Shohiyou/shohiyouZn"];

      // let totalZn: number = sum1.zn + sum2.zn;
      let totalZnCalc: number = sum1.zn + state.subTotalKazei - Math.abs(num);

      
      // this.totalCacheNex = totalZn;
      // 課税計算
      this.reqService.getZeikomi( totalZnCalc ).then(
        (response: any) => {
          if (response) {
            this.testCalcZkNex =  response.priceZk + state.subTotalHikazei;
          }
          resolve();
        },
        (err: any) => { reject(); } );
    });
    return promise;
  }

  // 合計金額を返す
  getTotalCalc() {
    let sum1: any = this.getTotalKazeiBase();
    let sum2: any = this.getTotalShohiyou();

    let totalZk: number = sum1.zk + sum2.zk;
    let totalZn: number = sum1.zn + sum2.zn;

    return { "totalSumZn":totalZn , "totalSumZk":totalZk, "totalCalcZk": this.totalCalcZk };
  }
  getTotalCalcNex() {
    let sum1: any = this.getTotalKazeiBaseNex();
    let sum2: any = this.getTotalShohiyou();

    let totalZk: number = sum1.zk + sum2.zk;
    let totalZn: number = sum1.zn + sum2.zn;

    return { "totalSumZn":totalZn , "totalSumZk":totalZk, "totalCalcZk": this.totalCalcZkNex };
  }

  getDemandAnswerNex() {
    return this.testCalcZkNex;
  }

  
}

